if (!customElements.get('jubilee-mobile-cart')) {
  customElements.define(
    'jubilee-mobile-cart',
    class JubileeMobileCart extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.sync = this.sync.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;

        document.documentElement.classList.add('jubilee-has-mobile-cart');
        this.addEventListener('click', this.handleClick);
        this.observeProductState();
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.submitObserver?.disconnect();
        this.priceObserver?.disconnect();
        window.setTimeout(() => {
          if (!document.querySelector('jubilee-mobile-cart')) {
            document.documentElement.classList.remove('jubilee-has-mobile-cart');
          }
        }, 0);
      }

      observeProductState() {
        /*
         * Observe only Dawn's real product controls. Observing the complete
         * product-info tree also observes this sticky bar; updating its own
         * disabled buttons then creates a MutationObserver feedback loop on
         * unavailable products and can prevent the rest of the page painting.
         */
        if (this.mainSubmitButton) {
          this.submitObserver = new MutationObserver(this.sync);
          this.submitObserver.observe(this.mainSubmitButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
          });
        }

        const priceBlock = this.productInfo.querySelector('[id^="price-"]');
        if (priceBlock) {
          this.priceObserver = new MutationObserver(this.sync);
          this.priceObserver.observe(priceBlock, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }

      get mainSubmitButton() {
        return this.productInfo?.querySelector('.product-form__submit[name="add"]');
      }

      get productForm() {
        return this.productInfo?.querySelector('form[data-type="add-to-cart-form"]');
      }

      sync() {
        const priceBlock = this.productInfo?.querySelector('[id^="price-"] .price');
        const priceSource = priceBlock?.classList.contains('price--on-sale')
          ? priceBlock.querySelector('.price__sale .price-item--sale')
          : priceBlock?.querySelector('.price__regular .price-item--regular');
        const priceTarget = this.querySelector('[data-jubilee-sticky-price]');
        const priceText = priceSource?.textContent?.replace(/\s+/g, ' ').trim();
        if (priceTarget && priceText) priceTarget.textContent = priceText;

        if (this.getAttribute('aria-busy') === 'true') return;

        const unavailable = !this.mainSubmitButton || this.mainSubmitButton.disabled || this.mainSubmitButton.getAttribute('aria-disabled') === 'true';
        this.querySelectorAll('[data-jubilee-action]').forEach((button) => {
          if (button.getAttribute('aria-busy') !== 'true' && button.disabled !== unavailable) {
            button.disabled = unavailable;
          }
        });
      }

      async handleClick(event) {
        const button = event.target.closest('[data-jubilee-action]');
        if (!button || button.disabled) return;

        if (button.dataset.jubileeAction === 'add') {
          this.mainSubmitButton?.click();
          return;
        }

        const paymentButton = this.productInfo?.querySelector('.shopify-payment-button__button:not([disabled])');
        if (paymentButton) {
          paymentButton.click();
          return;
        }

        await this.buyNow(button);
      }

      async buyNow(button) {
        const form = this.productForm;
        if (!form) return;

        const originalText = button.textContent;
        this.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Processing…';
        this.querySelectorAll('[data-jubilee-action]').forEach((actionButton) => {
          actionButton.disabled = true;
        });

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error('Unable to add this product');
          window.location.assign(this.dataset.checkoutUrl || '/checkout');
        } catch (error) {
          button.textContent = 'Try again';
          window.setTimeout(() => {
            button.textContent = originalText;
            button.removeAttribute('aria-busy');
            this.removeAttribute('aria-busy');
            this.sync();
          }, 1800);
        }
      }
    }
  );
}
